import apiInstance from '../lib/api/api.instance';
export const postSMSSetup = async (smsSetupPayload, urlStr) => {
    try {
        const response = await apiInstance.post(urlStr, smsSetupPayload);
        return response.data;
    }
    catch (error) {
        return error;
    }
};
export const postPreferredName = async (payload, urlStr) => {
    try {
        const response = await apiInstance.post(urlStr, payload);
        return response.data;
    }
    catch (error) {
        return error;
    }
};
export const fetchUserByPost = async (payload, urlStr) => {
    try {
        // const getAuthenticationInfoSuccess = checkAuthentication('/authenticate');
        // if (!getAuthenticationInfoSuccess) {
        //   throw new Error('Get user authentication failed');
        // }
        const response = await apiInstance.post(urlStr, payload);
        return response?.data;
    }
    catch (error) {
        return error;
    }
};
// export const checkAuthentication = (urlStr: string) => {
//   try {
//     apiInstance
//       .get(urlStr, {})
//       .then((resp) => {
//         if (resp.data == null) {
//           console.log('No authentication info found');
//         } else {
//           console.log('Get authentication info: ' + resp.data);
//           localStorage.setItem('idi-merchant-username', resp.data);
//         }
//       })
//       .catch((err) => {
//         console.error('error found !!!', err);
//         // handle CORS error
//         if (typeof err.response === 'undefined') {
//           console.log('call oauth endpoint');
//           // hit the backend endpoint to trigger oidc flow, after user login again user will back to current site
//           window.location.href = 'http://localhost:3000/oauth2/authorization/b2c_1a_signup_signin';
//         }
//         // if there is any 403 (or add others) error then return back to qa sso site
//         if (
//           typeof err.response != 'undefined' &&
//           (err.response.status == 403 || err.response.status == 401)
//         ) {
//           apiInstance.get('/logout');
//           //window.location.href = "https://login-qa.moneris.com";
//           window.location.href = 'http://localhost:3000/oauth2/authorization/b2c_1a_signup_signin';
//         }
//       });
//     return localStorage.getItem('idi-merchant-username') === null;
//   } catch (error) {
//     return error;
//   }
// };
export const updateUser = async (payload, urlStr) => {
    try {
        const response = await apiInstance.put(urlStr, payload);
        return response.data;
    }
    catch (error) {
        return error;
    }
};
export const getMD2Info = async ({ merchantNum }, urlStr) => {
    try {
        if (!merchantNum || merchantNum === null) {
            return {};
        }
        return (await apiInstance.post(urlStr, { merchantNumber: merchantNum })).data;
    }
    catch (error) {
        return error;
    }
};
